import { ChevronDownIcon as ChevronDown } from "@packages/ds";
import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const ExperimentHeader = styled.button`
  background: ${"var(--modal-snow-background-color,var(--snow))"};
  color: var(--color);
  border: none;
  display: inline-block;
  display: flex;
  margin: 0;
  margin-top: 16px;
  width: 100%;
  padding: 4px 0;
  align-items: center;
  cursor: pointer;

  h1 {
    font-size: 14px;
    ${semiBoldAlias()};
  }
`;

export const Chevron = styled(ChevronDown)<{ isOpen: boolean }>`
  transform: scaleY(${({ isOpen }) => (isOpen ? "-1" : "1")});
`;
